"use client"

import { useEffect, useState } from "react"
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts"
import axios from "axios"
import { Calendar } from "lucide-react" // Import Calendar icon

export default function SkillDistributionChart() {
  const [skillData, setSkillData] = useState([])
  const [filters, setFilters] = useState({ fromDate: "", toDate: "" })
  const [showFilter, setShowFilter] = useState(false)

  useEffect(() => {
    fetchData()
  }, [filters])

  const fetchData = async () => {
    try {
      const query = new URLSearchParams(filters).toString()
      const url = query ? `http://localhost:5000/skill-distribution?${query}` : `http://localhost:5000/skill-distribution`
      console.log("Fetching data from:", url) // Debugging: Log the API URL
      const response = await axios.get(url)
      console.log("API Response:", response.data) // Debugging: Log the API response
      setSkillData(response.data)
    } catch (error) {
      console.error("Error fetching skill distribution data:", error)
    }
  }

  return (
    <div className="relative">
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={skillData} layout="vertical" margin={{ top: 5, right: 30, left: 40, bottom: 30 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis type="number" label={{ value: "Count", position: "insideBottom", offset: -50 }} />
          <YAxis dataKey="name" type="category" width={80} label={{ value: "Skill", angle: -90, position: "insideLeft", offset: -15 }} />
          <Tooltip />
          <Legend />
          <Bar dataKey="count" fill="#8884d8" name="Professionals" />
          <Bar dataKey="totalProjects" fill="#82ca9d" name="Total Projects" />
        </BarChart>
      </ResponsiveContainer>
      <Calendar
        className="absolute top-2 right-2 w-5 h-5 text-gray-500 cursor-pointer"
        onClick={() => setShowFilter(!showFilter)}
      />
      {showFilter && (
        <div className="absolute top-10 right-0 z-10 p-4 bg-white border rounded shadow">
          <h3 className="mb-2 text-sm font-semibold">Skill Distribution Filter</h3>
          <label className="block mb-2 text-xs">
            From Date:
            <input
              type="date"
              className="block w-full p-1 border rounded"
              value={filters.fromDate}
              onChange={(e) => setFilters((prev) => ({ ...prev, fromDate: e.target.value }))}
            />
          </label>
          <label className="block mb-2 text-xs">
            To Date:
            <input
              type="date"
              className="block w-full p-1 border rounded"
              value={filters.toDate}
              onChange={(e) => setFilters((prev) => ({ ...prev, toDate: e.target.value }))}
            />
          </label>
          <button
            className="px-2 py-1 text-xs text-white bg-blue-500 rounded"
            onClick={() => setShowFilter(false)}
          >
            Apply
          </button>
        </div>
      )}
    </div>
  )
}
